/*
 * Shared Tailwind classes for the Alerts modals. The shared `Modal` component
 * wraps the JSX, but each modal opts out of `.modal-header` to apply this
 * white/centered chrome via the `header` prop. Keep these consistent so every
 * alert modal looks identical.
 */

export const MODAL_HEADER_CLASS = 'tw:flex tw:items-center tw:justify-between '
  + 'tw:bg-white tw:px-6 tw:pt-6'

export const MODAL_TITLE_CLASS = 'tw:text-lg! tw:font-medium! tw:text-gray-900! tw:m-0!'

export const MODAL_CLOSE_BTN_CLASS = 'tw:bg-transparent tw:border-0 tw:w-10 tw:h-10 '
  + 'tw:flex tw:items-center tw:justify-center tw:cursor-pointer '
  + 'tw:text-gray-600 tw:hover:text-gray-900'

export const MODAL_BODY_CLASS = 'tw:flex tw:flex-col tw:gap-6'

export const MODAL_FIELD_CLASS = 'tw:flex tw:flex-col tw:gap-1'

export const MODAL_LABEL_CLASS = 'tw:text-xs tw:font-medium tw:text-gray-950 tw:m-0!'

export const MODAL_FOOTER_SPLIT_CLASS = 'tw:flex tw:items-center tw:justify-between '
  + 'tw:w-full tw:gap-3'

export const MODAL_FOOTER_END_CLASS = 'tw:flex tw:items-center tw:justify-end '
  + 'tw:w-full tw:gap-3'

export const MODAL_FOOTER_ACTIONS_CLASS = 'tw:flex tw:gap-2'

export const MODAL_CANCEL_BTN_CLASS = 'tw:bg-transparent! tw:border-0! tw:text-gray-900!'

// Cards stacked inside the triggered-alert drawer (summary, files, comment).
export const DRAWER_CARD_CLASS = 'tw:flex! tw:flex-col tw:rounded-lg! tw:border '
  + 'tw:border-solid tw:border-gray-200 tw:bg-white tw:p-4'

export const DRAWER_CARD_TITLE_CLASS = 'tw:text-base! tw:font-medium! tw:text-gray-900! tw:m-0!'
